module.exports = __webpack_public_path__ + "static/home-artist-marketing-mobile-eb0036dabec68b329b82eed56376daec.png";